import { Box, Button, Flexbox, Icon, Typography } from '@hiiretail/synergy-ui';
import { Controller } from 'react-hook-form';
import { TextArea } from '../../../../common/components/TextArea/TextArea';
import { IconButton } from '@hiiretail/react-foundation-ui';
import FileUploadIcon from '@mui/icons-material/FileUpload';
import { CertificatesListComponent } from './CertificatesList.types';
import { CertificatesBox } from './CertificatesList.styles';

export const CertificatesList: CertificatesListComponent = ({
  fields,
  control,
  formState,
  onFileLoad,
  remove,
  append,
  identityProvider,
}) => {
  const canRemoveCertificate = fields.length > 1;

  return (
    <CertificatesBox p={4} mt={2} container direction="column" gutter={3}>
      <Box mb={1}>
        <Typography variant="body1" weight="bold">
          Certificates
        </Typography>
      </Box>
      <Box mb={1}>
        <Typography variant="caption" color={() => '#616161'}>
          A list of SAML provider X.509 certificates, including the -----BEGIN CERTIFICATE----- and
          -----END CERTIFICATE---- strings.
          <br />
          These are used for token-signing on the identity provider.
          <br />
          At least one certificate required.
          <Box style={{ gap: 8, display: 'flex' }}>
            <Icon.WarningTriangle fontSize="lg" color={() => '#eb680a'} />
            Usually certificates expire after some time. Make sure to add another one, when old
            certificate is about to expire.
          </Box>
        </Typography>
      </Box>
      {fields.map((item, index) => (
        <Flexbox item container key={item.id} alignItems="flex-end" gutter={4} width="100%">
          <Flexbox item width="85%">
            <Controller
              name={`certificates[${index}].value`}
              defaultValue={identityProvider?.certificates[index] ?? ''}
              control={control}
              render={({ field: { ref, value, onChange } }) => (
                <TextArea
                  fullWidth
                  rows={10}
                  required={fields.length === 1}
                  label={`Certificate ${index + 1}`}
                  placeholder="Enter a certificate ..."
                  name={`certificates[${index}].value`}
                  data-testid={`certificate-${index}`}
                  error={
                    formState.errors?.certificates?.[index]?.value?.message as string | undefined
                  }
                  type="text"
                  ref={ref}
                  value={value}
                  onChange={onChange}
                />
              )}
            />
          </Flexbox>
          <Flexbox container direction="column">
            <Flexbox item>
              {/* @ts-ignore */}
              <IconButton color="primary" component="label">
                <input
                  hidden
                  type="file"
                  name="file"
                  onChange={onFileLoad(index)}
                  data-testid={`upload-button-${index}`}
                />
                <FileUploadIcon />
              </IconButton>
            </Flexbox>
            <Flexbox item>
              <Button
                variant="icon"
                onClick={() => remove(index)}
                disabled={!canRemoveCertificate}
                data-testid={`delete-certificate-${index}`}
              >
                <Icon.Delete size="md" />
              </Button>
            </Flexbox>
          </Flexbox>
        </Flexbox>
      ))}
      <Box mt={4}>
        <Button
          type="button"
          variant="secondary"
          onClick={() => {
            append({ value: '' });
          }}
        >
          Add additional certificate
        </Button>
      </Box>
    </CertificatesBox>
  );
};
